// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.change-request {
  border: dotted #999290;
  border-width: 0 0 1px 0;
  padding: 10px 0;
  margin-bottom: 10px;
}
.change-request .change-request-title {
  font-weight: 600;
}
.change-request .change-request-text {
  white-space: pre-line;
  font-style: italic;
}
.change-request .change-request-text:before {
  content: '"';
}
.change-request .change-request-text:after {
  content: '"';
}
.va-trainee-day-calculator th,
.va-trainee-day-calculator-total th {
  font-weight: normal;
  padding-right: 4px;
  color: #4a4a4a;
}
.va-trainee-day-calculator label.total,
.va-trainee-day-calculator-total label.total {
  display: inline;
}
.va-budget {
  color: #4a4a4a;
}
.va-budget .summing-table,
.va-budget .budget-summary {
  width: 782px;
  text-align: left;
}
.va-budget .summing-table tbody tr:last-child td,
.va-budget .budget-summary tbody tr:last-child td {
  padding-bottom: 10px;
}
.va-budget .summing-table .soresu-money-field input[type=text],
.va-budget .budget-summary .soresu-money-field input[type=text] {
  margin: 0 6px 4px 0;
}
.va-budget .summing-table .soresu-text-field input[type=text],
.va-budget .budget-summary .soresu-text-field input[type=text] {
  margin: 0 4px 4px 0;
}
.va-budget .summing-table .soresu-text-area textarea,
.va-budget .budget-summary .soresu-text-area textarea {
  margin: 0;
  width: 381px;
  height: 24px;
}
.va-budget .summing-table .soresu-text-area .length-left,
.va-budget .budget-summary .soresu-text-area .length-left {
  display: none;
}
.va-budget .summing-table .money:after,
.va-budget .budget-summary .money:after {
  content: "\\00A0€";
}
.va-budget .summing-table .error,
.va-budget .budget-summary .error {
  color: #c9302c;
}
.va-budget .summing-table {
  margin-top: 13px;
}
.va-budget .summing-table caption {
  margin: 8px 0 16px 0;
  font-size: 18px;
  text-align: left;
  text-transform: uppercase;
}
.va-budget .summing-table thead tr {
  border-top: 10px transparent solid;
  border-bottom: 8px transparent solid;
}
.va-budget .summing-table tbody td {
  vertical-align: top;
  padding-bottom: 2px;
}
.va-budget .summing-table colgroup .label-column {
  width: 415px;
}
.va-budget .summing-table colgroup .description-column {
  width: 267px;
}
.va-budget .summing-table colgroup .amount-column {
  width: 100px;
}
.va-budget .summing-table .label-column.disabled {
  color: #807a78;
}
.va-budget .summing-table .amount-column {
  text-align: right;
}
.va-budget .summing-table tfoot {
  border-top: 1px solid #d9d9d9;
  font-weight: bold;
}
.va-budget .summing-table tfoot td {
  padding-top: 5px;
}
.va-budget .budget-summary {
  margin-top: 26px;
}
.va-budget .budget-summary-financing {
  overflow: hidden;
}
.va-budget .budget-summary h4 {
  font-weight: bold;
  margin: 14px 0;
}
.va-budget .budget-summary-financing-left {
  float: left;
  max-width: 50%;
}
.va-budget .budget-summary-financing-right {
  float: right;
  max-width: 50%;
}
.va-budget .budget-summary .amounts {
  margin-right: 20px;
}
.va-budget .budget-summary .percentages {
  margin-left: 20px;
}
.va-budget .budget-summary .amounts tbody tr:first-child td,
.va-budget .budget-summary .percentages tbody tr:first-child td {
  height: 50px;
}
.va-budget .budget-summary .amounts tbody tr:last-child td,
.va-budget .budget-summary .percentages tbody tr:last-child td {
  padding-top: 10px;
  padding-bottom: 0;
}
.va-budget .budget-summary .amount-label-column,
.va-budget .budget-summary .percentage-label-column {
  padding-right: 20px;
}
.va-budget .budget-summary .amount-value-column,
.va-budget .budget-summary .percentage-value-column {
  min-width: 120px;
  text-align: right;
}
.va-budget .budget-summary .soresu-money-field {
  margin: 0;
}
.va-budget .budget-summary .soresu-money-field input[type=text] {
  margin: 0;
}
.va-budget .budget-summary .soresu-money-field:after {
  content: "\\00A0€";
  margin-left: 4px;
}
.va-budget .budget-summary .percentage:after {
  content: "\\00A0%";
}
.va-budget .budget-summary .amount-value-column .money:not(.error):after {
  margin-left: 12px;
}
.soresu-growing-fieldset ol li.va-big-fieldset {
  margin: 20px 0 0 -90px;
}
.soresu-growing-fieldset .va-big-fieldset.disabled {
  color: #807a78;
}
.soresu-growing-fieldset .va-big-fieldset div.fieldset-elements {
  float: left;
  border-left: 1px solid #999290;
  border-right: 1px solid #999290;
  padding: 0 10px 0 21px;
  margin: 0 10px 40px 10px;
}
.soresu-growing-fieldset .va-big-fieldset div.fieldset-elements input[type=text],
.soresu-growing-fieldset .va-big-fieldset div.fieldset-elements input[type=email] {
  margin: 5px 10px 10px 0;
}
.soresu-growing-fieldset .va-big-fieldset div.fieldset-control {
  padding-top: 20px;
  overflow: hidden;
}
.soresu-preview .soresu-preview-growing-fieldset ol li.va-big-fieldset {
  margin: 0 0 40px -26px;
}
.soresu-preview .soresu-preview-growing-fieldset .va-big-fieldset div.fieldset-elements {
  border-left: 1px solid #999290;
  padding: 0 0 0 21px;
  margin: 0 0 0 20px;
}
.soresu-preview .va-budget .soresu-value {
  font-size: 16px;
}
.soresu-preview .va-budget .soresu-text-area.extra-extra-small,
.soresu-preview .va-budget .budget-summary .soresu-preview-element.extra-extra-small,
.soresu-preview .va-budget .soresu-text-area.extra-small,
.soresu-preview .va-budget .budget-summary .soresu-preview-element.extra-small,
.soresu-preview .va-budget .soresu-text-area.small,
.soresu-preview .va-budget .budget-summary .soresu-preview-element.small,
.soresu-preview .va-budget .soresu-text-area.medium,
.soresu-preview .va-budget .budget-summary .soresu-preview-element.medium,
.soresu-preview .va-budget .soresu-text-area.large,
.soresu-preview .va-budget .budget-summary .soresu-preview-element.large,
.soresu-preview .va-budget .soresu-text-area.extra-large,
.soresu-preview .va-budget .budget-summary .soresu-preview-element.extra-large {
  width: auto;
}
.soresu-preview .va-budget .budget-summary .amount-value-column .money:not(.error):after {
  margin-left: 0;
}
.va-register-number {
  margin-top: 5px;
  float: right;
}
.va-register-number .title {
  margin-right: 5px;
  font-weight: bold;
}
#topbar {
  width: 100%;
  background-color: #fff;
  position: fixed;
  top: 0;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
  z-index: 100;
}
#topbar #logo {
  display: inline-block;
  vertical-align: top;
  object-fit: contain;
  margin: 20px 70px 20px 20px;
}
@media print {
  #topbar #logo {
    margin-top: 0;
  }
}
#topbar .topbar-right {
  display: inline-block;
  vertical-align: top;
  margin: 25px 0 8px 0;
}
@media print {
  #topbar .topbar-right {
    margin-top: 5px;
    width: calc(100% - 350px);
  }
}
#topbar .topbar-title-and-save-status {
  display: inline-block;
  width: 480px;
}
@media print {
  #topbar .topbar-title-and-save-status {
    width: 100%;
  }
}
#topbar h1 {
  display: inline-block;
  vertical-align: middle;
  font-size: 22px;
  font-weight: normal;
  text-transform: uppercase;
}
#topbar #form-save-status {
  display: inline-block;
  vertical-align: middle;
  height: 50px;
  border-left: 1px solid #d9d9d9;
  margin-left: 30px;
  padding-left: 30px;
}
#topbar #form-save-status .messages {
  font-size: 13px;
  color: #4a4a4a;
  position: relative;
  top: 50%;
  transform: translateY(-50%);
}
@media print {
  #topbar #form-save-status {
    border: none;
    float: right;
    padding-left: 0;
  }
}
#topbar #form-controls {
  display: inline-block;
  vertical-align: middle;
  margin-left: 20px;
}
#topbar #form-controls .form-control,
#topbar #form-controls #toggle-language,
#topbar #form-controls #preview-button {
  display: inline-block;
}
#topbar #form-controls .form-control-button-tooltip {
  top: calc(100% + 6px);
  left: 50%;
  margin-left: -316px;
}
@media print {
  #topbar #form-controls {
    display: none;
  }
}
#topbar .important-info {
  display: inline-block;
  vertical-align: top;
  color: #c9302c;
  width: 480px;
}
@media print {
  #topbar .important-info {
    display: none;
  }
}
#topbar .environment-info {
  display: inline-block;
  margin-right: 10px;
}
#topbar .environment-info__name {
  text-transform: uppercase;
}
#topbar #avustushaku-has-ended-message {
  display: inline-block;
}
#topbar #form-error-summary {
  display: inline-block;
  font-size: 13px;
  margin-left: 20px;
}
#topbar .preview-link {
  display: inline-block;
  font-size: 13px;
  margin-left: 20px;
}
#topbar #form-error-summary + .preview-link {
  border-left: 1px solid #d9d9d9;
  padding-left: 15px;
  margin-left: 15px;
}
@media print {
  #topbar {
    position: relative;
    box-shadow: none;
  }
}
#top-container {
  width: 1300px;
  margin-left: auto;
  margin-right: auto;
}
@media print {
  #top-container {
    width: 100%;
  }
}
.muutoshakemus__section-checkbox-row {
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
}
.muutoshakemus__section-checkbox-row input[type="checkbox"] {
  width: 30px;
  height: 30px;
  cursor: pointer;
}
.muutoshakemus__section-checkbox-row label {
  padding-left: 1rem;
  cursor: pointer;
}
.muutoshakemus__form-section-content {
  margin-left: 2rem;
  margin-bottom: 2rem;
}
.muutoshakemus__perustelut {
  display: flex;
  flex-direction: column;
  margin-top: 15px;
}
.muutoshakemus__perustelut textarea {
  width: 70%;
  padding: 6px 7px 6px 8px;
  font-size: 0.9rem;
}
.muutoshakemus__input--contact {
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  padding: 8px;
  width: 280px;
}
.muutoshakemus__input-error {
  border: 2px solid #c9302c !important;
}
.muutoshakemus__error-message {
  font-size: 0.8rem;
  color: #c9302c;
  height: 0.8rem;
}
.muutoshakemus__page-title {
  display: flex;
  justify-content: space-between;
}
.muutoshakemus__top-content {
  background-color: white;
  padding: 160px 80px 10px;
}
.muutoshakemus__sub-title {
  font-family: Open Sans, sans-serif;
  font-style: normal;
  font-weight: bold !important;
  font-size: 19px !important;
  line-height: 27px;
  margin-bottom: 13px !important;
}
.muutoshakemus__label {
  font-weight: 600;
  letter-spacing: -0.025em;
}
.muutoshakemus__title {
  margin: 0 0 1rem !important;
  font-weight: bold !important;
  font-size: 28px;
  line-height: 27px;
}
.muutoshakemus__hanke-name__title {
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
}
.muutoshakemus__hanke-name__name {
  font-style: normal;
  font-weight: bold;
  font-size: 19px;
  line-height: 27px;
}
.existing-muutoshakemus__title {
  flex-shrink: 0;
  margin-right: 2rem;
  font-family: Open Sans, sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 19px;
  line-height: 27px;
  width: 256px;
}
.existing-muutoshakemus__form {
  flex-grow: 1;
}
.muutoshakemus__paatos-info {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 16px;
}
.muutoshakemus__kasitelty-date {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: -0.035em;
  color: #00516d;
}
.muutoshakemus__paatos-link {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: -0.035em;
  text-decoration-line: underline;
}
.muutoshakemus__date {
  border: 1px solid #eaeaea;
  box-sizing: border-box;
  padding: 1rem;
}
.muutoshakemus__header {
  font-style: normal;
  font-weight: 600 !important;
  font-size: 16px !important;
  line-height: 24px;
  display: flex;
  align-items: flex-end;
  letter-spacing: -0.025em;
  color: #1a1919 !important;
}
.muutoshakemus__form-row {
  display: flex;
  margin: 2rem 0;
}
.muutoshakemus__form-cell {
  display: flex;
  flex-direction: column;
}
.muutoshakemus__form-cell:not(:last-of-type) {
  margin-right: 1rem;
}
.muutoshakemus__form {
  width: 100%;
}
.muutoshakemus__section {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 0 2rem;
  box-sizing: border-box;
  border-bottom: 1px solid #d9d9d9;
}
.muutoshakemus__section-content {
  display: flex;
  max-width: 1300px;
  padding: 3rem 0;
  width: 100%;
}
.muutoshakemus__top-form {
  padding-top: 120px;
  background: white;
}
.muutoshakemus__top-form .muutoshakemus__section-content {
  flex-direction: column;
}
.va-old-browser-warning {
  position: fixed;
  top: 0;
  left: 0;
  height: 30px;
  width: 100%;
  z-index: 101;
  background-color: #efc211;
}
.va-old-browser-warning .soresu-remove {
  position: fixed;
  right: 5px;
  top: 4px;
}
.va-old-browser-warning .text {
  font-size: 13px;
  display: inline-block;
  margin-left: 100px;
  margin-top: 4px;
}
.va-old-browser-warning.hidden {
  display: none;
}
@media print {
  #container {
    margin-top: 20px;
    max-width: none;
  }
}
.container-section {
  margin-top: 130px;
  margin-left: 100px;
}
.container-section .checkbox-label {
  margin-right: 10px;
  margin-left: 5px;
}
.checkbox-label input[type="checkbox"] {
  margin-right: 5px;
}
.container-section .disabled {
  opacity: 0.4;
  pointer-events: none;
}
.refuse-comment label {
  display: block;
}
#debug-api-response {
  display: inline-flex;
  margin-top: 70px;
}
#top-container {
  display: flex;
}
div.muutospyynto-button-container {
  display: flex;
  align-items: center;
  line-height: 21px;
  font-size: 18px;
  font-weight: bold;
  letter-spacing: 0.01em;
}
div.notification-container {
  color: transparent;
}
div.notification-container div {
  display: flex;
  margin-left: 18px;
  height: 45px;
  width: 142px;
  visibility: visible;
  opacity: 1;
}
div.notification-container div.auto-hide {
  visibility: hidden;
  opacity: 0;
  transition: opacity 1s linear 5s, visibility 1s linear 5s;
}
div.notification-container div.success {
  color: #79C640;
}
div.notification-container div.error {
  color: #c9302c;
}
#send-muutospyynto-button {
  border: none;
  width: 198px;
  height: 43px;
  background: #79C640;
  color: #ffffff;
}
#send-muutospyynto-button:disabled {
  background: #cacaca;
}
`, "",{"version":3,"sources":["webpack://./soresu-form/web/va/style/soresu-va.less","webpack://./va-hakija/web/va/style/main.less","webpack://./va-hakija/web/va/style/topbar.less"],"names":[],"mappings":"AAEA;EACE,sBAAA;EACA,uBAAA;EACA,eAAA;EACA,mBAAA;ACDF;ADHA;EAMI,gBAAA;ACAJ;ADNA;EASI,qBAAA;EACA,kBAAA;ACAJ;ADCI;EACE,YAAA;ACCN;ADCI;EACE,YAAA;ACCN;ADIA;;EAEI,mBAAA;EACA,kBAAA;EACA,cAAA;ACFJ;ADFA;;EAOI,eAAA;ACDJ;ADKA;EACE,cAAA;ACHF;ADEA;;EAII,YAAA;EACA,gBAAA;ACFJ;ADHA;;EAOM,oBAAA;ACAN;ADPA;;EAUM,mBAAA;ACCN;ADXA;;EAaM,mBAAA;ACEN;ADfA;;EAiBQ,SAAA;EACA,YAAA;EACA,YAAA;ACER;ADrBA;;EAsBQ,aAAA;ACGR;ADzBA;;EA0BM,iBAAA;ACGN;AD7BA;;EA6BM,cAAA;ACIN;ADjCA;EAkCI,gBAAA;ACEJ;ADpCA;EAoCM,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;ACGN;AD1CA;EA4CQ,kCAAA;EACA,oCAAA;ACCR;AD9CA;EAkDQ,mBAAA;EACA,mBAAA;ACDR;ADlDA;EAwDQ,YAAA;ACHR;ADrDA;EA2DQ,YAAA;ACHR;ADxDA;EA8DQ,YAAA;ACHR;AD3DA;EAkEM,cAAA;ACJN;AD9DA;EAqEM,iBAAA;ACJN;ADjEA;EAwEM,6BAAA;EACA,iBAAA;ACJN;ADrEA;EA2EQ,gBAAA;ACHR;ADxEA;EAiFI,gBAAA;ACNJ;ADQI;EACE,gBAAA;ACNN;AD9EA;EAwFM,iBAAA;EACA,cAAA;ACPN;ADUI;EACE,WAAA;EACA,cAAA;ACRN;ADWI;EACE,YAAA;EACA,cAAA;ACTN;AD1FA;EAuGM,kBAAA;ACVN;AD7FA;EA2GM,iBAAA;ACXN;ADhGA;;EAiHU,YAAA;ACbV;ADpGA;;EAoHU,iBAAA;EACA,iBAAA;ACZV;ADzGA;;EA4HM,mBAAA;ACfN;AD7GA;;EAiIM,gBAAA;EACA,iBAAA;AChBN;ADlHA;EAsIM,SAAA;ACjBN;ADrHA;EAwIQ,SAAA;AChBR;ADkBM;EACE,iBAAA;EACA,gBAAA;AChBR;AD5HA;EAiJM,iBAAA;AClBN;AD/HA;EAqJM,iBAAA;ACnBN;ADwBA;EAEI,sBAAA;ACvBJ;AD2BI;EACE,cAAA;ACzBN;ADkBA;EAWM,WAAA;EACA,8BAAA;EACA,+BAAA;EACA,sBAAA;EACA,wBAAA;AC1BN;ADWA;;EAkBQ,uBAAA;ACzBR;ADOA;EAuBM,iBAAA;EACA,gBAAA;AC3BN;ADgCA;EAGM,sBAAA;AChCN;AD6BA;EAQQ,8BAAA;EACA,mBAAA;EACA,kBAAA;AClCR;ADwBA;EAgBM,eAAA;ACrCN;ADyCM;;;;;;;;;;;;EACE,WAAA;AC5BR;ADOA;EAyBM,cAAA;AC7BN;ADkCA;EACE,eAAA;EACA,YAAA;AChCF;AD8BA;EAKI,iBAAA;EACA,iBAAA;AChCJ;AC1NA;EACE,WAAA;EACA,sBAAA;EACA,eAAA;EACA,MAAA;EACA,0CAAA;EACA,YAAA;AD4NF;AClOA;EAWI,qBAAA;EACA,mBAAA;EACA,mBAAA;EACA,2BAAA;AD0NJ;ACxNI;EAAA;IACE,aAAA;ED2NJ;AACF;AC7OA;EAsBI,qBAAA;EACA,mBAAA;EACA,oBAAA;AD0NJ;ACxNI;EAAA;IACE,eAAA;IACA,yBAAA;ED2NJ;AACF;ACxPA;EAiCI,qBAAA;EACA,YAAA;AD0NJ;ACxNI;EAAA;IACE,WAAA;ED2NJ;AACF;ACjQA;EA0CI,qBAAA;EACA,sBAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;AD0NJ;ACxQA;EAkDI,qBAAA;EACA,sBAAA;EACA,YAAA;EACA,8BAAA;EACA,iBAAA;EACA,kBAAA;ADyNJ;AChRA;EA0DM,eAAA;EACA,cAAA;EACA,kBAAA;EACA,QAAA;EACA,2BAAA;ADyNN;ACtNI;EAAA;IACE,YAAA;IACA,YAAA;IACA,eAAA;EDyNJ;AACF;AC9RA;EAyEI,qBAAA;EACA,sBAAA;EACA,iBAAA;ADwNJ;ACnSA;;;EA8EM,qBAAA;AD0NN;ACxSA;EAkFM,qBAAA;EACA,SAAA;EACA,mBAAA;ADyNN;ACtNI;EAAA;IACE,aAAA;EDyNJ;AACF;AClTA;EA6FI,qBAAA;EACA,mBAAA;EACA,cAAA;EACA,YAAA;ADwNJ;ACtNI;EAAA;IACE,aAAA;EDyNJ;AACF;AC7TA;EAwGI,qBAAA;EACA,kBAAA;ADwNJ;ACtNI;EACE,yBAAA;ADwNN;ACpUA;EAiHI,qBAAA;ADsNJ;ACvUA;EAqHI,qBAAA;EACA,eAAA;EACA,iBAAA;ADqNJ;AC5UA;EA2HI,qBAAA;EACA,eAAA;EACA,iBAAA;ADoNJ;ACjVA;EAiII,8BAAA;EACA,kBAAA;EACA,iBAAA;ADmNJ;AChNE;EAAA;IACE,kBAAA;IACA,gBAAA;EDmNF;AACF;AChNA;EACE,aAAA;EACA,iBAAA;EACA,kBAAA;ADkNF;AChNE;EAAA;IACE,WAAA;EDmNF;AACF;AArWA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;AAuWF;AA1WA;EAMI,WAAA;EACA,YAAA;EACA,eAAA;AAuWJ;AA/WA;EAYI,kBAAA;EACA,eAAA;AAsWJ;AAlWA;EACE,iBAAA;EACA,mBAAA;AAoWF;AAjWA;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;AAmWF;AAtWA;EAMI,UAAA;EACA,wBAAA;EACA,iBAAA;AAmWJ;AA9VE;EACE,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;AAgWJ;AA5VA;EACE,oCAAA;AA8VF;AA3VA;EACE,iBAAA;EACA,cAAA;EACA,cAAA;AA6VF;AA1VA;EACE,aAAA;EACA,8BAAA;AA4VF;AAzVA;EACE,uBAAA;EACA,wBAAA;AA2VF;AAxVA;EACE,kCAAA;EACA,kBAAA;EACA,4BAAA;EACA,0BAAA;EACA,iBAAA;EACA,8BAAA;AA0VF;AAvVA;EACE,gBAAA;EACA,wBAAA;AAyVF;AAtVA;EACE,2BAAA;EACA,4BAAA;EACA,eAAA;EACA,iBAAA;AAwVF;AArVA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAuVF;AApVA;EACE,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;AAsVF;AAnVA;EACE,cAAA;EACA,kBAAA;EACA,kCAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,YAAA;AAqVF;AAlVA;EACE,YAAA;AAoVF;AAjVA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AAmVF;AAhVA;EACE,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,wBAAA;EACA,cAAA;AAkVF;AA/UA;EACE,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,wBAAA;EACA,+BAAA;AAiVF;AA9UA;EACE,yBAAA;EACA,sBAAA;EACA,aAAA;AAgVF;AA7UA;EACE,kBAAA;EACA,2BAAA;EACA,0BAAA;EACA,iBAAA;EACA,aAAA;EACA,qBAAA;EACA,wBAAA;EACA,yBAAA;AA+UF;AA5UA;EACE,aAAA;EACA,cAAA;AA8UF;AA3UA;EACE,aAAA;EACA,sBAAA;AA6UF;AA5UE;EACE,kBAAA;AA8UJ;AA1UA;EACE,WAAA;AA4UF;AAzUA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,sBAAA;EACA,gCAAA;AA2UF;AAxUA;EACE,aAAA;EACA,iBAAA;EACA,eAAA;EACA,WAAA;AA0UF;AAvUA;EACE,kBAAA;EACA,iBAAA;AAyUF;AA3UA;EAKI,sBAAA;AAyUJ;AArUA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;AAuUF;AA9UA;EAUI,eAAA;EACA,UAAA;EACA,QAAA;AAuUJ;AAnVA;EAgBI,eAAA;EACA,qBAAA;EACA,kBAAA;EACA,eAAA;AAsUJ;AAnUE;EACE,aAAA;AAqUJ;AAhUE;EAAA;IACE,gBAAA;IACA,eAAA;EAmUF;AACF;AAhUA;EACE,iBAAA;EACA,kBAAA;AAkUF;AA/TA;EACE,kBAAA;EACA,gBAAA;AAiUF;AA9TA;EACE,iBAAA;AAgUF;AA7TA;EACE,YAAA;EACA,oBAAA;AA+TF;AA5TA;EACE,cAAA;AA8TF;AA3TA;EACE,oBAAA;EACA,gBAAA;AA6TF;AA1TA;EACE,aAAA;AA4TF;AAzTA;EACE,aAAA;EACA,mBAAA;EAEA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;AA0TF;AAvTA;EACE,kBAAA;AAyTF;AA1TA;EAII,aAAA;EACA,iBAAA;EACA,YAAA;EACA,YAAA;EAEA,mBAAA;EACA,UAAA;AAwTJ;AAvTI;EACE,kBAAA;EACA,UAAA;EACA,yDAAA;AAyTN;AAtTI;EACE,cAAA;AAwTN;AAtTI;EACE,cAAA;AAwTN;AAnTA;EACE,YAAA;EACA,YAAA;EACA,YAAA;EAEA,mBAAA;EACA,cAAA;AAoTF;AAlTE;EACE,mBAAA;AAoTJ","sourcesContent":["@import \"~soresu-form/web/form/style/variables.less\";\n\n.change-request {\n  border: dotted @dark-gray;\n  border-width: 0 0 1px 0;\n  padding: 10px 0;\n  margin-bottom: 10px;\n  .change-request-title {\n    font-weight: 600;\n  }\n  .change-request-text {\n    white-space: pre-line;\n    font-style: italic;\n    &:before {\n      content: '\"';\n    }\n    &:after {\n      content: '\"';\n    }\n  }\n}\n\n.va-trainee-day-calculator, .va-trainee-day-calculator-total {\n  th {\n    font-weight: normal;\n    padding-right: 4px;\n    color: @form-label-black;\n  }\n  label.total {\n    display: inline;\n  }\n}\n\n.va-budget {\n  color: @form-label-black;\n\n  .summing-table, .budget-summary {\n    width: @section-width - 18px;\n    text-align: left;\n    tbody tr:last-child td {\n      padding-bottom: 10px;\n    }\n    .soresu-money-field input[type=text] {\n      margin: 0 6px 4px 0;\n    }\n    .soresu-text-field input[type=text] {\n      margin: 0 4px 4px 0;\n    }\n    .soresu-text-area {\n      textarea {\n        margin: 0;\n        width: ceil((@section-width / 2)) - 19px;\n        height: 24px;\n      }\n      .length-left {\n        display: none;\n      }\n    }\n    .money:after {\n      content: \"\\00A0€\";\n    }\n    .error {\n      color: @bright-red;\n    }\n  }\n\n  .summing-table {\n    margin-top: 13px;\n    caption {\n      margin: 8px 0 16px 0;\n      font-size: 18px;\n      text-align: left;\n      text-transform: uppercase;\n    }\n    thead {\n      tr {\n        // tr cannot have margin\n        border-top: 10px transparent solid;\n        border-bottom: 8px transparent solid;\n      }\n    }\n    tbody {\n      td {\n        vertical-align: top;\n        padding-bottom: 2px;\n      }\n    }\n    colgroup {\n      .label-column {\n        width: 415px;\n      }\n      .description-column {\n        width: 267px;\n      }\n      .amount-column {\n        width: 100px;\n      }\n    }\n    .label-column.disabled {\n      color: @darker-gray\n    }\n    .amount-column {\n      text-align: right;\n    }\n    tfoot {\n      border-top: 1px solid @light-gray;\n      font-weight: bold;\n      td {\n        padding-top: 5px;\n      }\n    }\n  }\n\n  .budget-summary {\n    margin-top: 26px;\n\n    &-financing {\n      overflow: hidden;  // clearfix\n    }\n\n    h4 {\n      font-weight: bold;\n      margin: 14px 0;\n    }\n\n    &-financing-left {\n      float: left;\n      max-width: 50%;\n    }\n\n    &-financing-right {\n      float: right;\n      max-width: 50%;\n    }\n\n    .amounts {\n      margin-right: 20px;\n    }\n\n    .percentages {\n      margin-left: 20px;\n    }\n\n    .amounts, .percentages {\n      tbody {\n        tr:first-child td {\n          height: 50px;\n        }\n        tr:last-child td {\n          padding-top: 10px;\n          padding-bottom: 0;\n        }\n      }\n    }\n\n    .amount-label-column,\n    .percentage-label-column {\n      padding-right: 20px;\n    }\n\n    .amount-value-column,\n    .percentage-value-column {\n      min-width: 120px;\n      text-align: right;\n    }\n\n    .soresu-money-field {\n      margin: 0;\n      input[type=text] {\n        margin: 0;\n      }\n      &:after {\n        content: \"\\00A0€\";\n        margin-left: 4px;\n      }\n    }\n\n    .percentage:after {\n      content: \"\\00A0%\";\n    }\n\n    .amount-value-column .money:not(.error):after {\n      margin-left: 12px;\n    }\n  }\n}\n\n.soresu-growing-fieldset {\n  ol li.va-big-fieldset {\n    margin: 20px 0 0 -90px;\n  }\n\n  .va-big-fieldset {\n    &.disabled {\n      color: @darker-gray;\n    }\n\n    div.fieldset-elements {\n      float: left;\n      border-left: 1px solid @dark-gray;\n      border-right: 1px solid @dark-gray;\n      padding: 0 10px 0 21px;\n      margin: 0 10px 40px 10px;\n\n      input[type=text], input[type=email] {\n        margin: 5px 10px 10px 0;\n      }\n    }\n\n    div.fieldset-control {\n      padding-top: 20px;\n      overflow: hidden;\n    }\n  }\n}\n\n.soresu-preview {\n  .soresu-preview-growing-fieldset {\n    ol li.va-big-fieldset {\n      margin: 0 0 40px -26px;\n    }\n\n    .va-big-fieldset {\n      div.fieldset-elements {\n        border-left: 1px solid @dark-gray;\n        padding: 0 0 0 21px;\n        margin: 0 0 0 20px;\n      }\n    }\n  }\n  .va-budget {\n    .soresu-value {\n      font-size: 16px;\n    }\n    .soresu-text-area,\n    .budget-summary .soresu-preview-element {\n      &.extra-extra-small, &.extra-small, &.small, &.medium, &.large, &.extra-large {\n        width: auto;\n      }\n    }\n    .budget-summary .amount-value-column .money:not(.error):after {\n      margin-left: 0;\n    }\n  }\n}\n\n.va-register-number {\n  margin-top: 5px;\n  float: right;\n\n  .title {\n    margin-right: 5px;\n    font-weight: bold;\n  }\n}\n","@import \"~soresu-form/web/va/style/soresu-va.less\";\n@import \"topbar\";\n\n.muutoshakemus__section-checkbox-row {\n  display: flex;\n  align-items: center;\n  margin-bottom: 1rem;\n\n  input[type=\"checkbox\"] {\n    width: 30px;\n    height: 30px;\n    cursor: pointer;\n  }\n\n  label {\n    padding-left: 1rem;\n    cursor: pointer;\n  }\n}\n\n.muutoshakemus__form-section-content {\n  margin-left: 2rem;\n  margin-bottom: 2rem;\n}\n\n.muutoshakemus__perustelut {\n  display: flex;\n  flex-direction: column;\n  margin-top: 15px;\n\n  textarea {\n    width: 70%;\n    padding: 6px 7px 6px 8px;\n    font-size: 0.9rem;\n  }\n}\n\n.muutoshakemus__input {\n  &--contact {\n    border: 1px solid @light-gray;\n    border-radius: 4px;\n    padding: 8px;\n    width: 280px;\n  }\n}\n\n.muutoshakemus__input-error {\n  border: 2px solid @bright-red !important;\n}\n\n.muutoshakemus__error-message {\n  font-size: 0.8rem;\n  color: @bright-red;\n  height: 0.8rem;\n}\n\n.muutoshakemus__page-title {\n  display: flex;\n  justify-content: space-between;\n}\n\n.muutoshakemus__top-content {\n  background-color: white;\n  padding: 160px 80px 10px;\n}\n\n.muutoshakemus__sub-title {\n  font-family: Open Sans, sans-serif;\n  font-style: normal;\n  font-weight: bold !important;\n  font-size: 19px !important;\n  line-height: 27px;\n  margin-bottom: 13px !important;\n}\n\n.muutoshakemus__label {\n  font-weight: 600;\n  letter-spacing: -0.025em;\n}\n\n.muutoshakemus__title {\n  margin: 0 0 1rem !important;\n  font-weight: bold !important;\n  font-size: 28px;\n  line-height: 27px;\n}\n\n.muutoshakemus__hanke-name__title {\n  font-style: normal;\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n.muutoshakemus__hanke-name__name {\n  font-style: normal;\n  font-weight: bold;\n  font-size: 19px;\n  line-height: 27px;\n}\n\n.existing-muutoshakemus__title {\n  flex-shrink: 0;\n  margin-right: 2rem;\n  font-family: Open Sans, sans-serif;\n  font-style: normal;\n  font-weight: bold;\n  font-size: 19px;\n  line-height: 27px;\n  width: 256px;\n}\n\n.existing-muutoshakemus__form {\n  flex-grow: 1;\n}\n\n.muutoshakemus__paatos-info {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  margin-bottom: 16px;\n}\n\n.muutoshakemus__kasitelty-date {\n  font-style: normal;\n  font-weight: normal;\n  font-size: 16px;\n  line-height: 24px;\n  letter-spacing: -0.035em;\n  color: @dark-blue;\n}\n\n.muutoshakemus__paatos-link {\n  font-style: normal;\n  font-weight: normal;\n  font-size: 16px;\n  line-height: 24px;\n  letter-spacing: -0.035em;\n  text-decoration-line: underline;\n}\n\n.muutoshakemus__date {\n  border: 1px solid #eaeaea;\n  box-sizing: border-box;\n  padding: 1rem;\n}\n\n.muutoshakemus__header {\n  font-style: normal;\n  font-weight: 600 !important;\n  font-size: 16px !important;\n  line-height: 24px;\n  display: flex;\n  align-items: flex-end;\n  letter-spacing: -0.025em;\n  color: @text-black !important;\n}\n\n.muutoshakemus__form-row {\n  display: flex;\n  margin: 2rem 0;\n}\n\n.muutoshakemus__form-cell {\n  display: flex;\n  flex-direction: column;\n  &:not(:last-of-type) {\n    margin-right: 1rem;\n  }\n}\n\n.muutoshakemus__form {\n  width: 100%;\n}\n\n.muutoshakemus__section {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n  padding: 0 2rem;\n  box-sizing: border-box;\n  border-bottom: 1px solid @light-gray;\n}\n\n.muutoshakemus__section-content {\n  display: flex;\n  max-width: 1300px;\n  padding: 3rem 0;\n  width: 100%;\n}\n\n.muutoshakemus__top-form {\n  padding-top: 120px;\n  background: white;\n\n  .muutoshakemus__section-content {\n    flex-direction: column;\n  }\n}\n\n.va-old-browser-warning {\n  position: fixed;\n  top: 0;\n  left: 0;\n  height: 30px;\n  width: 100%;\n  z-index: 101;\n  background-color: @yellow;\n\n  .soresu-remove {\n    position: fixed;\n    right: 5px;\n    top: 4px;\n  }\n\n  .text {\n    font-size: 13px;\n    display: inline-block;\n    margin-left: 100px;\n    margin-top: 4px;\n  }\n\n  &.hidden {\n    display: none;\n  }\n}\n\n#container {\n  @media print {\n    margin-top: 20px;\n    max-width: none;\n  }\n}\n\n.container-section {\n  margin-top: 130px;\n  margin-left: 100px;\n}\n\n.container-section .checkbox-label {\n  margin-right: 10px;\n  margin-left: 5px;\n}\n\n.checkbox-label input[type=\"checkbox\"] {\n  margin-right: 5px;\n}\n\n.container-section .disabled {\n  opacity: 0.4;\n  pointer-events: none;\n}\n\n.refuse-comment label {\n  display: block;\n}\n\n#debug-api-response {\n  display: inline-flex;\n  margin-top: 70px;\n}\n\n#top-container {\n  display: flex;\n}\n\ndiv.muutospyynto-button-container {\n  display: flex;\n  align-items: center;\n\n  line-height: 21px;\n  font-size: 18px;\n  font-weight: bold;\n  letter-spacing: 0.01em;\n}\n\ndiv.notification-container {\n  color: transparent;\n\n  div {\n    display: flex;\n    margin-left: 18px;\n    height: 45px;\n    width: 142px;\n\n    visibility: visible;\n    opacity: 1;\n    &.auto-hide {\n      visibility: hidden;\n      opacity: 0;\n      transition: opacity 1s linear 5s, visibility 1s linear 5s;\n    }\n\n    &.success {\n      color: @mantis-green;\n    }\n    &.error {\n      color: @bright-red;\n    }\n  }\n}\n\n#send-muutospyynto-button {\n  border: none;\n  width: 198px;\n  height: 43px;\n\n  background: @mantis-green;\n  color: #ffffff;\n\n  &:disabled {\n    background: @silver;\n  }\n}\n","@import \"~soresu-form/web/form/style/variables.less\";\n\n#topbar {\n  width: 100%;\n  background-color: #fff;\n  position: fixed;\n  top: 0;\n  box-shadow: 0 1px 2px 0 rgba(0,0,0,0.10);\n  z-index: 100;\n\n  @center-block-width: 480px;\n\n  #logo {\n    display: inline-block;\n    vertical-align: top;\n    object-fit: contain;\n    margin: 20px 70px 20px 20px;\n\n    @media print {\n      margin-top: 0;\n    }\n  }\n\n  .topbar-right {\n    display: inline-block;\n    vertical-align: top;\n    margin: 25px 0 8px 0;\n\n    @media print {\n      margin-top: 5px;\n      width: ~\"calc(100% - 350px)\";\n    }\n  }\n\n  .topbar-title-and-save-status {\n    display: inline-block;\n    width: @center-block-width;\n\n    @media print {\n      width: 100%;\n    }\n  }\n\n  h1 {\n    display: inline-block;\n    vertical-align: middle;\n    font-size: 22px;\n    font-weight: normal;\n    text-transform: uppercase;\n  }\n\n  #form-save-status {\n    display: inline-block;\n    vertical-align: middle;\n    height: 50px;\n    border-left: 1px solid @light-gray;\n    margin-left: 30px;\n    padding-left: 30px;\n\n    .messages {\n      font-size: 13px;\n      color: @form-label-black;\n      position: relative;\n      top: 50%;\n      transform: translateY(-50%);\n    }\n\n    @media print {\n      border: none;\n      float: right;\n      padding-left: 0;\n    }\n  }\n\n  #form-controls {\n    display: inline-block;\n    vertical-align: middle;\n    margin-left: 20px;\n\n    .form-control, #toggle-language, #preview-button {\n      display: inline-block;\n    }\n\n    .form-control-button-tooltip {\n      top: ~\"calc(100% + 6px)\";\n      left: 50%;\n      margin-left: -316px;\n    }\n\n    @media print {\n      display: none;\n    }\n  }\n\n  .important-info {\n    display: inline-block;\n    vertical-align: top;\n    color: @bright-red;\n    width: @center-block-width;\n\n    @media print {\n      display: none;\n    }\n  }\n\n  .environment-info {\n    display: inline-block;\n    margin-right: 10px;\n\n    &__name {\n      text-transform: uppercase;\n    }\n  }\n\n  #avustushaku-has-ended-message {\n    display: inline-block;\n  }\n\n  #form-error-summary {\n    display: inline-block;\n    font-size: 13px;\n    margin-left: 20px;\n  }\n\n  .preview-link {\n    display: inline-block;\n    font-size: 13px;\n    margin-left: 20px;\n  }\n\n  #form-error-summary + .preview-link {\n    border-left: 1px solid @light-gray;\n    padding-left: 15px;\n    margin-left: 15px;\n  }\n\n  @media print {\n    position: relative;\n    box-shadow: none;\n  }\n}\n\n#top-container {\n  width: @form-width;\n  margin-left: auto;\n  margin-right: auto;\n\n  @media print {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
